"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredGuildCompetitionWinnerResponseToJSON = exports.SponsoredGuildCompetitionWinnerResponseFromJSONTyped = exports.SponsoredGuildCompetitionWinnerResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function SponsoredGuildCompetitionWinnerResponseFromJSON(json) {
    return SponsoredGuildCompetitionWinnerResponseFromJSONTyped(json, false);
}
exports.SponsoredGuildCompetitionWinnerResponseFromJSON = SponsoredGuildCompetitionWinnerResponseFromJSON;
function SponsoredGuildCompetitionWinnerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'user': !(0, runtime_1.exists)(json, 'user') ? undefined : json['user'],
        'competition': !(0, runtime_1.exists)(json, 'competition') ? undefined : json['competition'],
        'reward': !(0, runtime_1.exists)(json, 'reward') ? undefined : (0, _1.SponsoredRewardResponseFromJSON)(json['reward']),
        'rewardType': !(0, runtime_1.exists)(json, 'rewardType') ? undefined : json['rewardType'],
        'mintTransactionId': !(0, runtime_1.exists)(json, 'mintTransactionId') ? undefined : json['mintTransactionId'],
        'debitTransactionId': !(0, runtime_1.exists)(json, 'debitTransactionId') ? undefined : json['debitTransactionId'],
        'accountDebitTransactionId': !(0, runtime_1.exists)(json, 'accountDebitTransactionId') ? undefined : json['accountDebitTransactionId'],
        'guild': !(0, runtime_1.exists)(json, 'guild') ? undefined : json['guild'],
        'notificationDismissed': !(0, runtime_1.exists)(json, 'notificationDismissed') ? undefined : json['notificationDismissed'],
    };
}
exports.SponsoredGuildCompetitionWinnerResponseFromJSONTyped = SponsoredGuildCompetitionWinnerResponseFromJSONTyped;
function SponsoredGuildCompetitionWinnerResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'user': value.user,
        'competition': value.competition,
        'reward': (0, _1.SponsoredRewardResponseToJSON)(value.reward),
        'rewardType': value.rewardType,
        'mintTransactionId': value.mintTransactionId,
        'debitTransactionId': value.debitTransactionId,
        'accountDebitTransactionId': value.accountDebitTransactionId,
        'guild': value.guild,
        'notificationDismissed': value.notificationDismissed,
    };
}
exports.SponsoredGuildCompetitionWinnerResponseToJSON = SponsoredGuildCompetitionWinnerResponseToJSON;
